// Generated by purs version 0.15.15
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Variant from "../Data.Variant/index.js";
import * as Data_Variant_Internal from "../Data.Variant.Internal/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Index from "../Foreign.Index/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
var fail = /* #__PURE__ */ Foreign.fail(Data_Identity.monadIdentity);
var on1 = /* #__PURE__ */ Data_Variant.on();
var inj1 = /* #__PURE__ */ Data_Variant.inj();
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var pure1 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
var alt = /* #__PURE__ */ Control_Alt.alt(/* #__PURE__ */ Control_Monad_Except_Trans.altExceptT(Data_List_Types.semigroupNonEmptyList)(Data_Identity.monadIdentity));
var ix = /* #__PURE__ */ Foreign_Index.ix(/* #__PURE__ */ Foreign_Index.indexableForeign(Data_Identity.monadIdentity))(/* #__PURE__ */ Foreign_Index.indexString(Data_Identity.monadIdentity));
var readString = /* #__PURE__ */ Foreign.readString(Data_Identity.monadIdentity);
var OneOf = function (x) {
    return x;
};
var variantEncodeNil = {
    variantEncode: function (v) {
        return Data_List_Types.Nil.value;
    }
};
var showOneOf = function (dictShow) {
    var show = Data_Show.show(dictShow);
    return {
        show: function (v) {
            return show(v);
        }
    };
};
var eqOneOf = function (dictEq) {
    var eq1 = Data_Eq.eq(dictEq);
    return {
        eq: function (v) {
            return function (v1) {
                return eq1(v)(v1);
            };
        }
    };
};
var decodeWithTagUNil = {
    "decodeWithTagU'": function (v) {
        return function (tag) {
            return function (v1) {
                return new Data_Either.Left("Unable to find tag for: " + tag);
            };
        };
    }
};
var decodeWithTagNil = {
    "decodeWithTag'": function (v) {
        return function (v1) {
            return function (v2) {
                return fail(new Foreign.ForeignError("Unable to match tag"));
            };
        };
    }
};
var decodeForeignVariantNil = {
    decodeForeignVariant: function (v) {
        return function (v1) {
            return fail(new Foreign.ForeignError("Unable to match any variant member."));
        };
    }
};
var variantEncode = function (dict) {
    return dict.variantEncode;
};
var encodeOneOf = function () {
    return function (dictVariantTags) {
        var variantTags = Data_Variant_Internal.variantTags(dictVariantTags);
        return function (dictVariantEncode) {
            var variantEncode1 = variantEncode(dictVariantEncode);
            return {
                encode: function (v) {
                    var tags = variantTags(Type_Proxy["Proxy"].value);
                    var encodes = variantEncode1(Type_Proxy["Proxy"].value);
                    var encoded = Data_Variant_Internal.lookup("encode")(v.type)(tags)(encodes)(v.value);
                    return encoded;
                }
            };
        };
    };
};
var variantEncodeCons = function (dictVariantEncode) {
    var variantEncode1 = variantEncode(dictVariantEncode);
    return function (dictEncode) {
        var encode = Foreign_Generic_Class.encode(dictEncode);
        return {
            variantEncode: function (v) {
                return new Data_List_Types.Cons(encode, variantEncode1(Type_Proxy["Proxy"].value));
            }
        };
    };
};
var on = function () {
    return function (dictIsSymbol) {
        var on3 = on1(dictIsSymbol);
        return function (p) {
            return function (f) {
                return function (g) {
                    return function (v) {
                        return on3(p)(f)(function ($127) {
                            return g(OneOf($127));
                        })(v);
                    };
                };
            };
        };
    };
};
var on2 = /* #__PURE__ */ on();
var inj = function () {
    return function (dictIsSymbol) {
        var inj2 = inj1(dictIsSymbol);
        return function (p) {
            return function (value) {
                return inj2(p)(value);
            };
        };
    };
};
var expand$prime = function () {
    return function (v) {
        return Unsafe_Coerce.unsafeCoerce;
    };
};
var expand$prime1 = /* #__PURE__ */ expand$prime();
var expand = function () {
    return expand$prime1(Type_Proxy["Proxy"].value);
};
var elimOne = function () {
    return function (dictIsSymbol) {
        var on3 = on2(dictIsSymbol);
        return function (p) {
            return function (f) {
                return on3(p)(f)(identity);
            };
        };
    };
};
var default$prime = function (fn) {
    return function (v) {
        return fn(Data_Unit.unit);
    };
};
var $$default = function (a) {
    return function (v) {
        return a;
    };
};
var decodeWithTagU$prime = function (dict) {
    return dict["decodeWithTagU'"];
};
var decodeWithTagUCons = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    var inj2 = inj1(dictIsSymbol);
    return function (dictDecode) {
        var decodeEither = Unscramble.decodeEither(dictDecode);
        return function (dictDecodeWithTagU) {
            var decodeWithTagU$prime1 = decodeWithTagU$prime(dictDecodeWithTagU);
            return function () {
                return {
                    "decodeWithTagU'": function (v) {
                        return function (tagFor) {
                            return function (value) {
                                var tag = reflectSymbol(Type_Proxy["Proxy"].value);
                                var $117 = tag === tagFor;
                                if ($117) {
                                    var v1 = decodeEither(value);
                                    if (v1 instanceof Data_Either.Right) {
                                        return pure(inj2(Type_Proxy["Proxy"].value)(v1.value0));
                                    };
                                    if (v1 instanceof Data_Either.Left) {
                                        return new Data_Either.Left("Failed to decode " + (tag + (": " + v1.value0)));
                                    };
                                    throw new Error("Failed pattern match at Data.OneOf (line 241, column 7 - line 243, column 65): " + [ v1.constructor.name ]);
                                };
                                return decodeWithTagU$prime1(Type_Proxy["Proxy"].value)(tagFor)(value);
                            };
                        };
                    }
                };
            };
        };
    };
};
var decodeWithTagU = function () {
    return function (dictDecodeWithTagU) {
        var decodeWithTagU$prime1 = decodeWithTagU$prime(dictDecodeWithTagU);
        return function (tag) {
            return function (f) {
                return decodeWithTagU$prime1(Type_Proxy["Proxy"].value)(tag)(f);
            };
        };
    };
};
var decodeWithTag$prime = function (dict) {
    return dict["decodeWithTag'"];
};
var decodeWithTagCons = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    var inj2 = inj1(dictIsSymbol);
    return function (dictDecode) {
        var decode = Foreign_Generic_Class.decode(dictDecode);
        return function (dictDecodeWithTag) {
            var decodeWithTag$prime1 = decodeWithTag$prime(dictDecodeWithTag);
            return function () {
                return {
                    "decodeWithTag'": function (v) {
                        return function (tagFor) {
                            return function (value) {
                                var tag = reflectSymbol(Type_Proxy["Proxy"].value);
                                var $122 = tag === tagFor;
                                if ($122) {
                                    return bind(decode(value))(function (v1) {
                                        return pure1(inj2(Type_Proxy["Proxy"].value)(v1));
                                    });
                                };
                                return alt(fail(Foreign.ForeignError.create("Did not match tag " + tag)))(decodeWithTag$prime1(Type_Proxy["Proxy"].value)(tagFor)(value));
                            };
                        };
                    }
                };
            };
        };
    };
};
var decodeWithTag = function () {
    return function (dictDecodeWithTag) {
        var decodeWithTag$prime1 = decodeWithTag$prime(dictDecodeWithTag);
        return function (tag) {
            return function (f) {
                return decodeWithTag$prime1(Type_Proxy["Proxy"].value)(tag)(f);
            };
        };
    };
};
var decodeForeignVariant = function (dict) {
    return dict.decodeForeignVariant;
};
var decodeForeignVariantCons = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    var inj2 = inj1(dictIsSymbol);
    return function (dictDecode) {
        var decode = Foreign_Generic_Class.decode(dictDecode);
        return function (dictDecodeForeignVariant) {
            var decodeForeignVariant1 = decodeForeignVariant(dictDecodeForeignVariant);
            return function () {
                return {
                    decodeForeignVariant: function (v) {
                        return function (value) {
                            var name = reflectSymbol(Type_Proxy["Proxy"].value);
                            return alt(bind(bind(ix(value)("tag"))(readString))(function (tag) {
                                var $125 = tag === name;
                                if ($125) {
                                    return bind(decode(value))(function (v1) {
                                        return pure1(inj2(Type_Proxy["Proxy"].value)(v1));
                                    });
                                };
                                return fail(Foreign.ForeignError.create("Did not match variant tag " + name));
                            }))(decodeForeignVariant1(Type_Proxy["Proxy"].value)(value));
                        };
                    }
                };
            };
        };
    };
};
var decodeOneOf = function () {
    return function (dictDecodeForeignVariant) {
        var decodeForeignVariant1 = decodeForeignVariant(dictDecodeForeignVariant);
        return {
            decode: function (o) {
                return decodeForeignVariant1(Type_Proxy["Proxy"].value)(o);
            }
        };
    };
};
var case_ = function (v) {
    return Partial_Unsafe.unsafeCrashWith("impossible");
};
export {
    decodeForeignVariant,
    decodeWithTag$prime,
    decodeWithTagU$prime,
    variantEncode,
    OneOf,
    inj,
    $$default as default,
    default$prime,
    case_,
    on,
    expand,
    expand$prime,
    elimOne,
    decodeWithTag,
    decodeWithTagU,
    variantEncodeNil,
    variantEncodeCons,
    encodeOneOf,
    decodeForeignVariantNil,
    decodeForeignVariantCons,
    decodeOneOf,
    showOneOf,
    eqOneOf,
    decodeWithTagNil,
    decodeWithTagCons,
    decodeWithTagUNil,
    decodeWithTagUCons
};
